import React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import QRCode from 'react-qr-code';
import styles from './qrcode-container.less';

const QRCodeContainer = ({
  className,
  content,
  qrCodeClickable,
  children,
  size = 108,
  bgColor = '#F6F8FB',
  fgColor = '#000000',
}) => (
  <div
    className={cx(styles.qrCodeContainer, className)}
    style={{ backgroundColor: bgColor }}
  >
    {content && (
      <div className={styles.qrCodeWrapper}>
        {qrCodeClickable ? (
          <a href={content} target="_blank">
            <QRCode
              value={content}
              size={108}
              bgColor={bgColor}
              fgColor={fgColor}
            />
          </a>
        ) : (
          <QRCode
            value={content}
            size={108}
            bgColor={bgColor}
            fgColor={fgColor}
          />
        )}
      </div>
    )}
    {children}
  </div>
);

QRCodeContainer.propTypes = {
  content: PropTypes.string,
  className: PropTypes.string,
  qrCodeClickable: PropTypes.bool,
  children: PropTypes.node,
  size: PropTypes.number,
  bgColor: PropTypes.string,
  fgColor: PropTypes.string,
};

QRCodeContainer.defaultProps = {
  content: undefined,
  className: undefined,
  qrCodeClickable: false,
  children: undefined,
  size: 108,
  bgColor: '#F6F8FB',
  fgColor: '#000000',
};

export default QRCodeContainer;
